import { Link } from 'react-router-dom';
import type { Work } from '@/types/work';
import { useFavorites } from '@/hooks/useFavorites';

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  const { isFavorite, toggle } = useFavorites();
  const favorite = isFavorite(work.id);
  const typeLabel = work.type === 'tv' ? '电视剧' : '电影';

  return (
    <article className="group flex flex-col">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <Link
          to={`/detail/${work.id}`}
          className="block h-full w-full cursor-pointer"
          aria-label={`查看《${work.title}》详情`}
        >
          <img
            src={work.cover}
            alt={`《${work.title}》海报`}
            title={`${work.title} ${typeLabel}剧情介绍与演员表`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/65 to-transparent" />
        </Link>

        <span className="absolute left-2 top-2 rounded-md bg-black/55 px-2 py-0.5 text-xs text-background-50">{typeLabel}</span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
          {work.rating.toFixed(1)}
        </span>

        <button
          type="button"
          onClick={() => toggle(work.id)}
          aria-label={favorite ? `取消收藏《${work.title}》` : `收藏《${work.title}》`}
          title={favorite ? '取消收藏' : '收藏'}
          className="absolute bottom-2 right-2 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-50/90 text-foreground-800 transition-colors hover:bg-background-50 hover:text-primary-600"
        >
          <i className={favorite ? 'ri-heart-3-fill text-primary-500' : 'ri-heart-3-line'} />
        </button>
      </div>

      <Link to={`/detail/${work.id}`} className="mt-2 block cursor-pointer">
        <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {work.title}
        </h3>
      </Link>
      <p className="mt-1 truncate text-xs text-foreground-600 md:text-sm">
        {work.year} · {work.region}
      </p>
      <p className="mt-0.5 truncate text-xs text-foreground-500">{work.actors.slice(0, 2).join(' / ')}</p>
    </article>
  );
}